import { TypeBox } from '../TypeBox/TypeBox'
import { useEffect, useState } from 'react'
import {
    ScoopButton,
    ScoopSpinner,
    ScoopTextField,
    ScoopText,
    ScoopDialog,
    ScoopColumn,
} from '../../../../ui'
import { AccordionConfig } from '../../../../modals/dialogs/source/ConfigDialog/ConfigDialog'
import { EVENTS, trackEvent } from '../../../../../events'
import styles from './SelectType.module.scss'

export const SelectType = ({
    saveLoading,
    setStep,
    onClose,
    setType,
    isSnapshotDefault,
    stepBack,
    createInbox,
    handleCreateInbox,
    isLoading,
    setDescription,
    handleContinue,
    disableSpreadsheet,
    disableAdvanced,
    continueButton,
}) => {
    const [active, setActive] = useState('')
    const [inboxName, setInboxName] = useState('')
    const [expanded, setExpanded] = useState(false)
    const [isMostRecent, setIsMostRecent] = useState(false)
    const [isIncremental, setIsIncremental] = useState(false)
    const [isMultipleLoads, setIsMultipleLoads] = useState(false)
    const [workbookRange, setWorkbookRange] = useState('')

    useEffect(() => {
        if (isSnapshotDefault) setActive('Snapshot')
        else setActive('Transactional')
    }, [isSnapshotDefault])

    return (
        <ScoopDialog
            open
            onClose={() => {
                onClose()
                setStep && setStep(0)
            }}
            maxWidth="md"
            actions={
                <>
                    <ScoopButton
                        variant="grey"
                        onClick={() => {
                            setType(active)
                            setStep && setStep(0)
                            stepBack && stepBack()
                        }}
                    >
                        Back
                    </ScoopButton>
                    <ScoopButton
                        disabled={
                            !active || (createInbox && !inboxName) || isLoading || saveLoading
                        }
                        onClick={() => {
                            createInbox && handleCreateInbox(inboxName, active)
                            setType(active)
                            !createInbox &&
                                handleContinue({
                                    isIncremental,
                                    isMostRecent,
                                    isMultipleLoads,
                                    isSnapshot: active,
                                })
                        }}
                        loading={saveLoading}
                    >
                        {continueButton}
                    </ScoopButton>
                </>
            }
        >
            <ScoopColumn className={styles.container}>
                <ScoopText className={styles.title}>Create New Dataset</ScoopText>
                <ScoopText className={styles.description}>
                    Select the type of Dataset you'd like to create. For more information,{' '}
                    <a
                        href="https://www.scoopanalytics.com/help"
                        target="_blank"
                        className={styles.link}
                        rel="noreferrer"
                        onClick={() =>
                            trackEvent(EVENTS.ACCOUNT.CONTACT_SUPPORT, {
                                source: 'dataset_select_type',
                            })
                        }
                    >
                        click here for help.
                    </a>
                </ScoopText>
                {createInbox && (
                    <ScoopColumn className={styles.inputsContainer}>
                        <ScoopTextField
                            onChange={(e) => setInboxName(e.target.value)}
                            value={inboxName}
                            padding={'8px 16px'}
                            label={'Dataset Name'}
                        />
                        <ScoopTextField
                            label={'Description (optional)'}
                            multiline
                            rows={4}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </ScoopColumn>
                )}
                {!createInbox && (
                    <ScoopColumn className={styles.optionsContainer}>
                        <TypeBox
                            title={'Transactional'}
                            description={
                                'Accept all new reports as transactions, i.e. as additional records to the existing database. All records are cumulative.'
                            }
                            active={active}
                            setActive={setActive}
                            enabled={true}
                        ></TypeBox>
                        <TypeBox
                            title={'Snapshot'}
                            description={
                                'Snapshots allow tracking of individual items and their state over time. The unique key in each report is used to track changes for each item. '
                            }
                            active={active}
                            setActive={setActive}
                            enabled={true}
                        ></TypeBox>
                        {!disableAdvanced && (
                            <AccordionConfig
                                isIncremental={isIncremental}
                                setIsIncremental={setIsIncremental}
                                isMostRecent={isMostRecent}
                                setIsMostRecent={setIsMostRecent}
                                isMultipleLoads={isMultipleLoads}
                                setIsMultipleLoads={setIsMultipleLoads}
                                workbookRange={workbookRange}
                                setWorkbookRange={setWorkbookRange}
                                expanded={expanded}
                                setExpanded={setExpanded}
                                isTransactional={active === 'Transactional'}
                                disableSpreadsheet={disableSpreadsheet}
                            />
                        )}
                    </ScoopColumn>
                )}
                {isLoading && <ScoopSpinner size={72} />}
            </ScoopColumn>
        </ScoopDialog>
    )
}
